import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { InputBase } from '@material-ui/core'
import './ProjectName.scss'

function ProjectName({
  isLoading,
  projectName,
  editFileName
}) {
  const fileNameInputEl = useRef(null)

  const highlightText = () => {
    fileNameInputEl.current.setSelectionRange(0, fileNameInputEl.current.value.length)
  }

  return (
    <React.Fragment>
      <div className="project_name">
        <span >Project Name: </span>
        <InputBase
          value={projectName || ''}
          placeholder="Please Enter Project Name"
          inputProps={{ 'data-testid': 'project-name', 'aria-label': 'naked', title: projectName, maxLength: 50 }}
          onChange={e =>
            editFileName({ projectName: e.target.value })
          }
          onFocus={highlightText}
          inputRef={fileNameInputEl}
        />
      </div>
      {!(projectName && projectName.trim()) && !isLoading &&
        <div className="project_name_validation">
          <span>* Project name is missing</span>
        </div>
      }
    </React.Fragment>
  )
}

ProjectName.propTypes = {
  isLoading: PropTypes.bool,
  projectName: PropTypes.string,
  editFileName: PropTypes.func
}

export default ProjectName
